import { useLocation, useNavigate } from "@solidjs/router";
import Editor from "~/js/editor";
import { clearWorkspace } from "~/js/workspace";
import { routerConfig } from "~/solidJs/app/MainApp/models";
import {
	getWorkspacesStore,
	setWorkspacesStore
} from "~/solidJs/entities/WorkspaceListEntity/models/wrokspaceListContext";
import { setSaveCurrentProjectStore } from "~/solidJs/widgets/SaveNewProjectModal/SaveNewProjectModal";

export const useLogoNavigation = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const createEmptyWorkspace = async () => {
		// Очищаем текущий workspace
		await clearWorkspace();

		// Сбрасываем store на пустое состояние
		setWorkspacesStore({
			activeProjectId: null,
			activeProjectName: null,
			projectsAmount: getWorkspacesStore().projectsAmount,
			activeWorkspaceLink: null,
			isOpenedByLink: false,
			isStateSaved: true,
			isOpenPending: false
		});

		// Помечаем граф как сохраненный
		if (Editor.context.graph) {
			Editor.context.graph.toggleIsSavedState(true);
		}
	};

	const navigateToHome = async () => {
		const isOnHomePage = location.pathname === routerConfig.workspace.absolute;

		if (isOnHomePage) {
			// Если мы уже на главной странице, просто создаем пустое workspace
			await createEmptyWorkspace();
		} else {
			// Если нет - переходим на главную страницу
			navigate(routerConfig.workspace.absolute, { replace: true });
		}
	};

	const handleLogoClick = (e: MouseEvent) => {
		e.preventDefault();

		// Проверяем, есть ли граф и несохраненные изменения
		const graph = Editor.context.graph;
		const hasUnsavedChanges = graph && !graph.getIsSaved;

		if (hasUnsavedChanges) {
			// Показываем модальное окно с предложением сохранить
			setSaveCurrentProjectStore({
				isVisible: true,
				onCloseCallback: () => {
					// Переходим на главную страницу после закрытия модального окна
					navigateToHome();
				}
			});
		} else {
			// Если нет несохраненных изменений, переходим сразу
			navigateToHome();
		}
	};

	return {
		handleLogoClick
	};
};
